import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { useT } from "@/lib/i18n";

const SesionClosing = () => {
  const t = useT();
  return (
    <section className="py-20 md:py-28 text-center">
      <div className="max-w-2xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-serif italic text-3xl md:text-4xl text-charcoal leading-[1.15]">
            {t("free.closing.quote")}
          </p>
          <p className="mt-6 text-[11px] tracking-[0.3em] uppercase text-charcoal/55">{t("free.closing.author")}</p>
          <Link
            to="/metodo-tao"
            data-testid="closing-link-metodo"
            className="mt-10 inline-flex items-center gap-2 text-charcoal text-sm font-medium border-b border-terracotta pb-1 hover:text-terracotta transition-colors"
          >
            {t("free.closing.link")} <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default SesionClosing;
